/* Tocar una imagen de la galería abre el visor a pantalla completa (PhotoSwipe)
   con zoom real (pinch / doble-tap). Reemplaza al botón flotante de "expandir":
   el usuario simplemente toca la foto para ver el detalle (clave en alta costura).
   Dispara el opener <a data-pswp-image> que PhotoSwipe ya tiene registrado. */
(function () {
  if (window.__galleryImageZoom) return;
  window.__galleryImageZoom = true;

  document.addEventListener('click', function (e) {
    // Solo imágenes del slider principal de producto (no thumbnails ni videos)
    var slide = e.target.closest('.swiper-slide[data-media-type="image"]');
    if (!slide) return;
    var gallery = slide.closest('#product-media-gallery');
    if (!gallery) return;
    // No interferir si se tocó un control (flecha, etc.)
    if (e.target.closest('button, [data-prev-icon], [data-next-icon]')) return;

    var mediaId = slide.getAttribute('data-media-id');
    var opener = gallery.querySelector(
      '.product__gallery-opener a[data-media-id="' + mediaId + '"]'
    ) || gallery.querySelector('.product__gallery-opener a[data-pswp-image]');

    if (opener) {
      e.preventDefault();
      opener.click();
    }
  });
})();
